import React from 'react'
import './path.scss';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
const Path = () => {
    const options = {
        nav: true,
        items: 3,
        margin: 20,
        loop: false,
        autoplay: false,
        autoplayTimeout: 3000,
        navText: [
            `<svg xmlns="http://www.w3.org/2000/svg" width="58" height="35" viewBox="0 0 58 35" fill="none">
  <rect x="56.7287" y="33.9205" width="56.0698" height="32.8409" transform="rotate(-180 56.7287 33.9205)" fill="#CDD7DA"/>
  <rect x="56.7287" y="33.9205" width="56.0698" height="32.8409" transform="rotate(-180 56.7287 33.9205)" stroke="#C1CBCE" stroke-width="0.800997"/>
  <path d="M27.6952 27.7858L23.4548 27.7858L17.703 17.5107L21.9433 17.5107L27.6952 27.7858Z" fill="#329879"/>
  <path d="M27.6952 7.21411L23.4548 7.21411L17.703 17.4891L20.3754 19.2655L21.9433 17.4891L27.6952 7.21411Z" fill="#329879"/>
  <path d="M37.5237 19.4402L25.7505 19.4402L27.9114 15.5655L39.6846 15.5655L37.5237 19.4402Z" fill="#329879"/>
</svg>`,
            `<svg xmlns="http://www.w3.org/2000/svg" width="57" height="35" viewBox="0 0 57 35" fill="none">
  <rect x="0.529649" y="1.07958" width="56.0698" height="32.8409" fill="#CDD7DA"/>
  <rect x="0.529649" y="1.07958" width="56.0698" height="32.8409" stroke="#C1CBCE" stroke-width="0.800997"/>
  <path d="M29.5631 7.21429L33.8035 7.2143L39.5553 17.4893L35.315 17.4893L29.5631 7.21429Z" fill="#329879"/>
  <path d="M29.5631 27.7859L33.8035 27.7859L39.5553 17.5109L36.8829 15.7346L35.315 17.5109L29.5631 27.7859Z" fill="#329879"/>
  <path d="M19.7346 15.5598H31.5078L29.3469 19.4345H17.5737L19.7346 15.5598Z" fill="#329879"/>
</svg>`,
        ],
        responsive: {
            0: { items: 1 },
            768: { items: 1 },
            1200: { items: 1 },
        },
    };
    return (
        <>
            <section className='aqua_main'>
                <div className='custom-container'>
                    <div className='inner_aqua'>
                        <div className="main-content">
                            <h5>Your Path to peak market momentum <span>with Gems Launchpad Pro</span></h5>
                            <div className='leftborder'>
                                <p>
                                    Even exceptional Web3 projects with solid infrastructure and proven use cases face significant fundraising challenges in today's market.
                                </p>
                                <p>
                                    We are a battle-tested crypto launchpad providing projects with structured support for fundraising, community access, and transparent validation.
                                </p>
                            </div>
                        </div>
                        <div className='carousel_div'>
                            <div className='card_carousel'>
                                <OwlCarousel className="owl-theme" {...options}>
                                    <div className="item">
                                        <p className='phase-text'>Phase 1</p>
                                        <h6>Strategic Planning</h6>
                                        <p className="para">An in-depth assessment of your project's needs. Together, we develop a precise capital raising plan aligned with your objectives, including smart tokenomics design and an effective launch strategy.</p>
                                    </div>
                                    <div className="item">
                                        <p className='phase-text'>Phase 2</p>
                                        <h6>Building the Fundraising Infrastructure</h6>
                                        <p className="para">Our professional team assists in establishing all necessary infrastructure - from secure smart contracts to an advanced management dashboard.</p>
                                    </div>
                                    <div className="item">
                                        <p className='phase-text'>Phase 3</p>
                                        <h6>Accessing Our Affiliate Leader Network</h6>
                                        <p className="para">Gain access to a network of over +4,300 crypto opinion leaders and influencers. These individuals are an integral part of the vast Gems ecosystem, standing by for the next project to be discovered.</p>
                                    </div>
                                    <div className="item">
                                        <p className='phase-text'>Phase 4</p>
                                        <h6>Launch and Community Growth</h6>
                                        <p className="para">At the crucial moment, our expert team provides close guidance for a successful launch. Our system enables oversight of the entire fundraising process, emphasizing active community building.</p>
                                    </div>
                                    <div className="item">
                                        <p className='phase-text'>Phase 5</p>
                                        <h6>Post-Launch</h6>
                                        <p className="para">Gems takes pride in a rich network of partnerships and collaborations, providing graduating projects with unique listing opportunities in top-tier exchanges.</p>
                                    </div>

                                </OwlCarousel>

                            </div>

                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Path
